import React from "react"
import styles from "./Logo.module.css"

const Logo = () => <div className={styles.logo} />

Logo.propTypes = {}

export default Logo
